import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAhjFeeSchedulesAdminQueryVariables = Types.Exact<{
  jurisdictionId: Types.Scalars['uuid']['input'];
}>;


export type GetAhjFeeSchedulesAdminQuery = { __typename?: 'query_root', ahj_fee_schedules: Array<{ __typename?: 'ahj_fee_schedules', id: any, submission_type_id: any, ahj_base_amount: any, ollie_percentage: any, ollie_floor_amount: any, ollie_ceiling_amount?: any | null, included_cycles_limit: number, extra_resubmittal_price: any, active: boolean, submission_type: { __typename?: 'plan_review_submission_types', id: any, name: string }, ahj_fee_schedule_variables: Array<{ __typename?: 'ahj_fee_schedule_variables', id: any, variable_key: string, variable_label: string, rate_per_unit: any, free_quantity: any, is_required: boolean, sort_order: number }> }> };


export const GetAhjFeeSchedulesAdminDocument = gql`
    query getAhjFeeSchedulesAdmin($jurisdictionId: uuid!) {
  ahj_fee_schedules(
    where: {jurisdiction_id: {_eq: $jurisdictionId}}
    order_by: {created_at: asc}
  ) {
    id
    submission_type_id
    ahj_base_amount
    ollie_percentage
    ollie_floor_amount
    ollie_ceiling_amount
    included_cycles_limit
    extra_resubmittal_price
    active
    submission_type {
      id
      name
    }
    ahj_fee_schedule_variables(order_by: {sort_order: asc}) {
      id
      variable_key
      variable_label
      rate_per_unit
      free_quantity
      is_required
      sort_order
    }
  }
}
    `;

/**
 * __useGetAhjFeeSchedulesAdminQuery__
 *
 * To run a query within a React component, call `useGetAhjFeeSchedulesAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAhjFeeSchedulesAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAhjFeeSchedulesAdminQuery({
 *   variables: {
 *      jurisdictionId: // value for 'jurisdictionId'
 *   },
 * });
 */
export function useGetAhjFeeSchedulesAdminQuery(baseOptions: Apollo.QueryHookOptions<GetAhjFeeSchedulesAdminQuery, GetAhjFeeSchedulesAdminQueryVariables> & ({ variables: GetAhjFeeSchedulesAdminQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAhjFeeSchedulesAdminQuery, GetAhjFeeSchedulesAdminQueryVariables>(GetAhjFeeSchedulesAdminDocument, options);
      }
export function useGetAhjFeeSchedulesAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAhjFeeSchedulesAdminQuery, GetAhjFeeSchedulesAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAhjFeeSchedulesAdminQuery, GetAhjFeeSchedulesAdminQueryVariables>(GetAhjFeeSchedulesAdminDocument, options);
        }
export function useGetAhjFeeSchedulesAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAhjFeeSchedulesAdminQuery, GetAhjFeeSchedulesAdminQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAhjFeeSchedulesAdminQuery, GetAhjFeeSchedulesAdminQueryVariables>(GetAhjFeeSchedulesAdminDocument, options);
        }
export type GetAhjFeeSchedulesAdminQueryHookResult = ReturnType<typeof useGetAhjFeeSchedulesAdminQuery>;
export type GetAhjFeeSchedulesAdminLazyQueryHookResult = ReturnType<typeof useGetAhjFeeSchedulesAdminLazyQuery>;
export type GetAhjFeeSchedulesAdminSuspenseQueryHookResult = ReturnType<typeof useGetAhjFeeSchedulesAdminSuspenseQuery>;
export type GetAhjFeeSchedulesAdminQueryResult = Apollo.QueryResult<GetAhjFeeSchedulesAdminQuery, GetAhjFeeSchedulesAdminQueryVariables>;